<template>
  <div class></div>
</template>
<script>
export default {
  name: "logout",
  //destroy token in server and here
  created() {
    this.$store.dispatch("userauth/aDestroyToken").then(response => {
      if (response) {
        this.$router.push({ name: "Login" });
      }
    });
    //redirect to home page
  }
};
</script>